<template>
    <FormBuilder :formData="formData" :formValue="formValue"></FormBuilder>
</template>

<script>
    import FormBuilder from "../../FormBuilder.vue";
    import API from "../../../../Api";
    
    

    export default {
        components: {
            FormBuilder            
        },
        props: {
            formValue: {
                type: Object,
                required: true
            }            
        },       
        mounted: function () {
            this.showHideMinimumAndPrefferred();
            //this.RenderSiteEnrolmentTreatmentGroups(this.formValue,null);
        },
        data: function() {
            return {                      
                formData: [
                    {                        
                        title: "Sites",
                        description: "Setup and configure \"Site\"",
                        anchor: "3.1",
                        forms: [{
                            type: "fileupload",
                            buttonText: "Import sites",
                            extraClass: "plus inlineblock",
                            fileUploadPath: "study/ConvertSites",
                            callback: (_, data) => {
                                if (!confirm("Upload will overwrite current site list"))
                                    return false;

                                if (data.data && Array.isArray(data.data))
                                    this.importSites(data.data)
                                }
                            }, 
                            {
                            type: "button",
                            buttonText: "Sites template",
                            extraClass: "download inlineblock",
                            callback: this.downloadSitesTemplate
                            },
                            {
                                type: "button",
                                buttonText: "Export sites",
                                extraClass: "download inlineblock",
                                callback: this.exportSites
                            }
                            , {
                                type: "button",
                                buttonText: "Export site enrolments",
                                extraClass: "download inlineblock",
                                callback: this.downloadSiteEnrollments
                            },
                            {
                                type: "fileupload",                               
                                buttonText: "Import site enrolments",
                                extraClass: "plus inlineblock",
                                fileUploadPath: "study/ConvertEnrolments?studyId=" + this.$route.params.id,
                                callback: (_, data) => {
                                    if (!confirm("Upload will overwrite current site enrolments"))
                                        return false;

                                    if (data.data && Array.isArray(data.data)) {
                                        //console.log("data.data.length:" + data.data.length);
                                        this.importSiteEnrolments(data.data)
                                    }
                                } 
                             }
                         /* ,
                          {
                            type: "fileupload",
                            buttonText: "Import snapshot",
                            extraClass: "plus inlineblock",
                            fileUploadPath: "study/ConvertSnapShot?studyId=" + this.$route.params.id,
                            style: this.isSuperAdmin() ? "" : "display:none;",
                            callback: (_, data) => {
                              if (!confirm("Remember importing a snapshot will mean that the simulation will only be accurate after this date"))
                                return false;

                              if (data.data && Array.isArray(data.data)) {
                                //console.log("data.data.length:" + data.data.length);
                                //this.importSnapShot(data.data)
                              }
                            }
                          },
                          {
                            type: "button",
                            
                            buttonText: "Import snapshot (last successful run).",
                            extraClass: "plus inlineblock",
                            style: this.isSuperAdmin() ? "" : "display:none;",
                            callback: (item, global, formValue, isDelete) => {
                              //debugger;
                              this.importLastSuccessfulSnapShot()
                            }
                          }
                          ,
                          {
                            type: "button",
                            buttonText: "Reset snapshot",
                            style: this.isSuperAdmin() ? "" : "display:none;",
                            extraClass: "plus inlineblock",
                            callback: (item, global, formValue, isDelete) => {
                              //debugger;
                              this.formValue.snapshots = null;
                            }
                          }*/
                          ,
                          {
                            type: "sectionarray",
                            label: "Sites",
                            value: "sites",
                            buttonText: "Create site",                            
                            grid: "grid-50w",
                            callback: (item, global, formValue, isDelete) => {
                                if (isDelete) {
                                    this.handleSiteDeleted(item.id);
                                }
                            },
                            forms: [{
                                type: "guid",
                                value: "id"
                            }, {
                                type: "text",
                                label: "Name",
                                value: "name",
                                required: true
                            }, 
                                {
                                    type: "select",
                                    label: "Country",
                                    value: "address.country",
                                    required: true,
                                    preValues: "countries"
                                },
                                {
                                type: "text",
                                label: "Destination address",
                                value: "address.street"
                            }, {
                                type: "text",
                                label: "City",
                                value: "address.city"
                            }, {
                                type: "text",
                                label: "Post code",
                                value: "address.postCode"
                            }, {
                                type: "text",
                                label: "State",
                                value: "address.state"
                            }, {
                                type: "number",
                                label: "Max subjects",
                                minValue: "",
                                placeholder: "Leave empty to let system decide",
                                value: "maxSubjects",
                                helper: "Indicate if the site has a limit on the number of subjects that may be enrolled. Or after the enrollment period in the study has ended indicate the number of subjects the site did enrol"
                            }, {
                                type: "calendar",
                                label: "Start date (First dispensing visit)",
                                value: "start",
                                required: true
                            },
                                {
                                    type: "number",
                                    required: true,
                                    label: "Initial enrolment rate - Per 28 days",
                                    helper: "Initial enrolment rate is the minimum enrollment for a site/hospital per 28 days. Decimals are allowed/encouraged.",
                                    value: "projection.min"
                                }, {
                                    type: "hidden",
                                    value: "projection.duration",
                                    preValue: "28"
                                }
                                
                                , {
                                    type: "sectionarray",
                                    label: "Enrolment rates",
                                    outerToggleIsClosed: true,                                    
                                    extraClass: "grid-full",
                                    buttonText: "Add enrolment rate",
                                    value: "projectionPeriods",
                                    grid: "grid-50w",
                                    forms: [
                                        {
                                            type: "calendar",
                                            required: true,
                                            label: "Start date",
                                            value: "from",
                                            placeholder: "If more than one period, please assign date"
                                        }
                                        , 
                                        {
                                            type: "number",
                                            required: true,
                                            label: "Subjects per 28 days",
                                            value: "projection.min"
                                        }                                                           
                                       ]
                                }
                               
                                , {
                                    type: "sectionarray",
                                    label: "Actual enrolled",
                                    /*description: "You can replace enrolment for certian periods here.",*/
                                    extraClass: "grid-full",
                                    outerToggleIsClosed: true,
                                    callback: (item, global, formValue, isDelete) => {
                                        this.RenderSiteEnrolmentTreatmentGroups(formValue, global, item);
                                    },                                    
                                    buttonText: "Add enrolment actual",
                                    value: "enrolmentPeriods",
                                    grid: "grid-50w",
                                    forms: [
                                      
                                         {
                                            type: "calendar",
                                            required: true,
                                            label: "Start",
                                            value: "start",
                                            placeholder: ""
                                        }, {
                                            type: "number",
                                            label: "Period (days)",
                                            value: "days",
                                            required: true
                                        },
                                           {
                                            type: "sectionpicker",
                                            label: "Treatmentgroup",
                                            extraClass: "grid-full",
                                            value: "enrolmentPeriodTreatmentGroupPicker",                                            
                                            required: true,                                            
                                            sectionPicker: [{
                                                label: "All treatmentgroups"
                                            }, {
                                                label: "Per treatmentgroup"
                                            }],
                                            
                                            forms: [{
                                                    type: "section",
                                                    label: "All treatmentgroups",
                                                    extraClass: "grid-full",
                                                    sectionPickerKey: "All treatmentgroups",
                                                    forms: [{
                                                        type: "number",
                                                        label: "Enrolled Actual",
                                                        value: "allTreatmentGroupsEnrolled",
                                                        required: true
                                                    }]
                                                },                                                
                                                {
                                                    //type: "section",
                                                    type: "sectionarraysimple",
                                                    label: "Enrolled per treatmentgroup",
                                                    sectionPickerKey: "Per treatmentgroup",                                                                                                        
                                                    grid: "grid-50w",
                                                    extraClass: "grid-full",
                                                    value: "enrolled",                                                    
                                                    disableDelete: true,
                                                    forms: [
                                                      /*
                                                      work in progress!
                                                    {
                                                      label: "Treatment groups",
                                                      type: "treatmentgroup-for-actuals",
                                                      required: false,
                                                      extraClass: "grid-full"
                                                    }                                                    
                                                    ,
                                                    */
                                                    {
                                                          type: "guid",
                                                          value: "treatmentGroupId"
                                                      },
                                                      {
                                                          type: "label",
                                                          label: "Treatmentgroup",
                                                          value: "description"
                                                      }, 
                                                      {
                                                          type: "number",
                                                          label: "Actual enrolment",
                                                          required: false,
                                                          value: "enrolled"
                                                      }
                                                        
                                                    ]                                                
                                                }
                                                ]
                                        }                     
                                    ]
                                }   
                                /*
                                , {
                                    type: "sectionarray",
                                    label: "Stock adjustments",
                                    outerToggleIsClosed: true,
                                    extraClass: "grid-full",
                                    buttonText: "Add stock adjustment",
                                    value: "stockAdjustments",
                                    grid: "grid-100w",
                                    callback: (formValue, global, locationInfo) => {
                                      
                                       //we must check if the planned batch is allowed in the supply chain, then remove it 
                                       if (!global) return;
                                       if (this.NullOrUndefined(locationInfo)) return;
                                       if (this.NullOrUndefined(locationInfo.stockAdjustments)) return;
                                       if (this.NullOrUndefined(global.supplyChain)) return;
                                       
                                       
                                      // let supplyChains = global.supplyChain.supplyChains;
                                        //debugger;
                                        //this.setStockAdjustments("stockAdjustments", this.formValue.stockAdjustments);
                                    },
                                    forms: [{
                                      type: "planned-batch-stock-adjustments",
                                      label: "Planned batch",
                                      value: "plannedBatchGuid"
                                    }, {
                                      type: "calendar",
                                      label: "Date",
                                      value: "date"
                                    }
                                    , {
                                        type: "number",
                                        label: "Stock level",
                                        value: "stockLevel"
                                      }
                                    ]
                                }*/
                                , {
                                type: "sectionarray",
                                label: "Supply plan",
                                outerToggleIsClosed: true,
                                extraClass: "grid-full",
                                buttonText: "Add supply plan",
                                value: "supplyPlans",
                                grid: "grid-50w",
                                callback: (formValue, global, array) => {
                                    if (!global) return;
                                    this.changeLocationSupplyPlan("sites", this.formValue.sites);
                                },
                                forms: [{
                                    type: "select",
                                    label: "Supply plan",
                                    value: "supplyPlan",
                                    preValues: {
                                        field: "supplyPlans",
                                        value: "id",
                                        name: "description"
                                    },
                                    callback: (formValue) => {
                                        formValue.startDate = null;
                                        this.changeLocationSupplyPlan("sites", this.formValue.sites);
                                    }
                                }, {
                                    type: "calendar",
                                    label: "Date",
                                    value: "startDate"
                                }]
                                }]
                        }]
                    },
                    {
                    title: "Site Ancillaries",
                    description: "Optional, Setup and configure \"Per site Ancillaries\".",
                    anchor: "3.2",
                    forms: [ {
                      type: "sectionarray",
                      label: "Ancillaries",
                      value: "siteAncillaries",
                      buttonText: "Create site ancillary",
                      grid: "grid-50w",
                        callback: (item, global, formValue, isDelete) => {
                          if (isDelete) {
                            this.handleSiteAncillaryDeleted(item.id);
                          }
                        }
                      ,
                      forms: [{
                        type: "guid",
                        value: "id"
                      }, {
                        type: "text",
                        label: "Name",
                        value: "name",
                        required: true,
                        callback: (_, globals) => {

                        }
                        }
                        , {
                          type: "number",
                          label: "Quantity per site",
                          value: "quantity",
                          required: true,
                          callback: (_, globals) => {
                            
                          }
                        }
                        , {
                          type: "number",
                          label: "Cost per unit",
                          value: "cost",
                          required: true,
                          callback: (_, globals) => {

                          }
                        }
                        , {
                          type: "number",
                          label: "Days it must arrive before site start",
                          value: "daysBeforeSiteStart",
                          required: true,
                          callback: (_, globals) => {

                          }
                        }
                        , {
                          type: "typeahead",
                          value: "siteIds",
                          label: "Sites",
                          multiple: true,
                          appendAll: true,
                          required: true,
                          preValues: {
                            field: "sites",
                            name: "name",
                            value: "id",
                            groupBy: "address.country"
                          },
                          callback: () => {
                           // this.changeSupplyPlans("sites", this.formValue.sites);
                          }
                        }
                      
                      ]
                    }

                    ]
                  },
                    {
                        title: "Depots",
                        description: "Setup and configure \"Depots\"",
                        anchor: "3.3",
                        forms: [{
                            type: "fileupload",
                            buttonText: "Import depots",
                            extraClass: "plus inlineblock",
                            fileUploadPath: "study/ConvertDepots",
                            callback: (_, data) => {
                                if (!confirm("Upload will overwrite current depot list"))
                                    return false;

                                if (data.data && Array.isArray(data.data))
                                    this.importDepots(data.data)
                            }
                        }, {
                            type: "button",
                            buttonText: "Depots template",
                            extraClass: "download inlineblock",
                            callback: this.downloadDepotsTemplate
                        }, {
                            type: "button",
                            buttonText: "Export depots",
                            extraClass: "download inlineblock",
                            callback: this.exportDepots
                        }, {
                            type: "sectionarray",
                            label: "Depots",
                            value: "depots",
                            buttonText: "Create depot",
                            grid: "grid-50w",
                            callback: (item, global, formValue, isDelete) => {
                                if (isDelete) {
                                    this.handleDepotDeleted(item.id);
                                }
                            },
                            forms: [{
                                type: "guid",
                                value: "id"
                            }, {
                                type: "text",
                                label: "Name",
                                value: "name",
                                required: true/*,
                                callback: (_, globals) => {
                                    this.updateMetaNameReferences(globals);
                                }*/
                            }, 
                                {
                                    type: "select",
                                    label: "Country",
                                    value: "address.country",
                                    required: true,
                                    preValues: "countries"
                                },
                                {
                                type: "text",
                                label: "Description",
                                value: "description"
                            }, 
                           
                            {
                            type: "text",
                            label: "Destination address",
                            value: "address.street"
                            }, {
                                type: "text",
                                label: "City",
                                value: "address.city"
                            }, {
                                type: "text",
                                label: "Post code",
                                value: "address.postCode"
                            }, {
                                type: "text",
                                label: "State",
                                value: "address.state"
                            }
                            /*
                              , {
                                type: "sectionarray",
                                label: "Stock adjustments",
                                outerToggleIsClosed: true,
                                extraClass: "grid-full",
                                buttonText: "Add stock adjustment",
                                value: "stockAdjustments",
                                grid: "grid-100w",
                                callback: (formValue, global, locationInfo) => {

                                  //we must check if the planned batch is allowed in the supply chain, then remove it 
                                  if (!global) return;
                                  if (this.NullOrUndefined(locationInfo)) return;
                                  if (this.NullOrUndefined(locationInfo.stockAdjustments)) return;
                                  if (this.NullOrUndefined(global.supplyChain)) return;


                                  // let supplyChains = global.supplyChain.supplyChains;
                                  //debugger;
                                  //this.setStockAdjustments("stockAdjustments", this.formValue.stockAdjustments);
                                },
                                forms: [{
                                  type: "planned-batch-stock-adjustments",
                                  label: "Planned batch",
                                  value: "plannedBatchGuid"
                                }, {
                                  type: "calendar",
                                  label: "Date",
                                  value: "date"
                                }
                                  , {
                                    type: "number",
                                    label: "Stock level",
                                    value: "stockLevel"
                                  }
                                ]
                              }*/
                              
                            ]
                        }]
                    }, 
                    {
                        title: "Supply Plans",
                        description: "Setup supply plans for sites and depots. All sites must have a supply plan per DUN",
                        anchor: "3.4",
                        forms: [
                            {                                 
                                type: "checkbox",
                                label: "Autosuggest supply plans",
                                description: "If checked, a monte-carlo algorithm will decide the best supply plan for each location. User inserted supply plans are ignored.",
                                value: "autoGenerateSupplyPlans",
                                required: true,                                
                                callback: () => {
                                    this.autoGenerateSupplyPlans();
                                }
                            }
                            ,                            
                            {
                                type: "select",
                                label: "Preferred supply strategy for sites when autogenerating",     
                                id: "preferredSiteSupplyPlanSelect",                                
                                value: "preferredSiteSupplyPlan",                                                            
                                preValues: "supplyStrategies",
                                style: "display:none;",
                                required: true,
                                callback: () => { this.showHideMinimumAndPrefferred(); }
                            },
                            {
                              type: "section",
                              label: "Advanced settings (optional)",
                              extraClass: "grid-full",
                              forms: [
                                {
                                  type: "number",
                                  label: "Monte carlo iterations",
                                  helper: "For faster performance you can set monte-carlo iterations. We recommend minimum 50-1000, leave empty to use default 2000. As we try to minimize search area sampling never has to be above 1000. The lower the faster. Each iteration is an entire sample of all supply plans.",
                                  value: "monteCarloIterations",
                                  inline: "Iterations",
                                  required: false
                                }
                                ,
                                {
                                  type: "number",
                                  label: "Monte carlo attempts",
                                  helper: "How many times to rerun a monte-carlo simulation, leave empty to use default 8.",
                                  value: "monteCarloAttempts",
                                  inline: "Attempts",
                                  required: false
                                }
                                ,
                                {
                                  type: "number",
                                  label: "Allow stockout from montecarlo attempt",
                                  helper: "From which attempt should we allow stockout, leave empty to not allow.",
                                  value: "monteCarloAttemptsBeforeAllowStockOut",
                                  inline: "Attempt no",
                                  required: false
                                },
                                {
                                  type: "number",
                                  label: "Stock out limit",
                                  helper: "If you allow autogenerate, you can also set max stockouts. This is good if you impossible to autogenerate and want to see why. Set to -1 for unlimited.",
                                  value: "autoGenerateStockOutLimit",
                                  inline: "Duns",
                                  required: false
                                }
                                ,
                                {
                                  type: "number",
                                  label: "Maximum waste reducing iterations",
                                  helper: "After monte-carlo we further optimise the picked candidate. You can set how many iterations you will allow. Default is 8.",
                                  value: "maxReduceWasteIterations",
                                  inline: "Iterations",
                                  required: false
                                }
                                ,
                                {
                                  type: "number",
                                  label: "Minimum waste improvement percent",
                                  helper: "After each waste reduction we compare to previous to see if improvement is high enough.",
                                  value: "minWasteReducePercent",
                                  inline: "Percent",
                                  required: false
                                }
                              ]
                            },
                            {
                                type: "sectionarray",
                                label: "Threshold",
                                id: "predictionThreshold",
                                style: "",
                                extraClass: "grid-full",                                
                                value: "dispensingUnits",
                                grid: "grid-33w",
                                forms: [
                                    {
                                        type: "label",
                                        label: "Dispensingunit",                                        
                                        value: "name"
                                    }
                                    , {
                                        type: "number",
                                        label: "Minimum threshold",
                                        required: false,
                                        value: "predictionMinimumThreshold"
                                    }
                                    , {
                                        type: "number",
                                        label: "Maximum threshold",
                                        required: false,
                                        value: "predictionMaximumThreshold"
                                    }
                                ]
                            }
                            ,
                            {
                            type: "sectionarray",
                            label: "Supply plans (sites)",
                            extraClass: "grid-full supply-plans",
                            buttonText: "Create supply plan",
                            value: "supplyPlans",
                            grid: "grid-50w",
                            forms: [{
                                type: "guid",
                                value: "id"
                            }, {
                                type: "text",
                                label: "Name",
                                required: true,
                                value: "description"
                            }, {
                                type: "select",
                                label: "Dispensing Unit",
                                value: "dispensingUnit",
                                required: true,
                                preValues: {
                                    field: "dispensingUnits",
                                    value: "id",
                                    name: "name"
                                }
                            }, {
                                type: "sectionpicker",
                                label: "Type",
                                extraClass: "grid-full",
                                value: "SelectedStrategyType",
                                required: true,
                                sectionPicker: [{
                                    label: "Floor/Ceiling"
                                }, {
                                    label: "Prediction"
                                }],
                                forms: [{
                                    type: "section",
                                    label: "Floor/Ceiling",
                                    extraClass: "grid-full",
                                    sectionPickerKey: "Floor/Ceiling",
                                    forms: [{
                                        type: "number",
                                        label: "Initial",
                                        value: "resupplyStrategy.initial",
                                        required: true
                                    }, {
                                        type: "number",
                                        label: "Floor",
                                        value: "trigger.floor",
                                        required: true
                                    }, {
                                        type: "number",
                                        label: "Ceiling",
                                        value: "resupplyStrategy.ceiling",
                                        required: true
                                    }]
                                }, {
                                    type: "section",
                                    label: "Prediction",
                                    extraClass: "grid-full",
                                    sectionPickerKey: "Prediction",
                                    forms: [{
                                        type: "number",
                                        label: "Initial",
                                        value: "resupplyStrategy.initial",
                                        required: true
                                    }, {
                                        type: "number",
                                        label: "Threshold",
                                        value: "trigger.threshold",
                                        required: true
                                    }, {
                                        type: "number",
                                        label: "Short window",
                                        value: "trigger.shortWindow",
                                        required: true
                                    }, {
                                        type: "number",
                                        label: "Long window",
                                        value: "resupplyStrategy.longWindow",
                                        required: true
                                    }]
                                }]
                            }, {
                                type: "calendar",
                                label: "Default start date",
                                value: "defaultStartDate",
                                helper: "If this supply plan is the first valid supply plan for the DUN add the study start date"
                            }, {
                                type: "typeahead",
                                value: "sites",
                                label: "Sites",
                                multiple: true,
                                appendAll: true,
                                preValues: {
                                    field: "sites",
                                    name: "name",
                                    value: "id",
                                    groupBy: "address.country"
                                },
                                callback: () => {
                                    this.changeSupplyPlans("sites", this.formValue.sites);
                                }
                            }
                            ]
                            },
                            {
                                type: "fileupload",
                                buttonText: "Import supply plans (excel)",
                                extraClass: "plus inlineblock",
                                fileUploadPath: "supplyplan/ConvertSupplyPlans",
                                callback: (_, data) => {
                                    if (!confirm("Upload will overwrite current supply plans"))
                                        return false;

                                    if (data.data && Array.isArray(data.data))
                                        this.importSupplyPlansByExcel(data.data)
                                }
                            }
                            ,
                            {
                                type: "button",                                
                                style: this.ShowHideSupplyPlanJsonStyle(),
                                buttonText: "Import supply plans from last successful run.",
                                extraClass: "plus inlineblock",                                
                                callback: (_, data) => {                                   
                                    this.importSupplyPlansByJsonLocal()
                                }
                            }
                            ]
                    }
                   
                    ]
                
            }        
        }
        
        ,             
        methods: {
            isSuperAdmin() {
              return this.$store.state.member.isSuperAdmin;
            },
          handleSiteAncillaryDeleted: function (siteAncillaryId)
          {
          
            var siteAncilleries = this.formValue.siteAncilleries;
            
            if (this.NullOrUndefined(siteAncilleries))
            {
              return;
            }
            
            //this is only designed if you have it displayed on sites...
          },
            importLastSuccessfulSnapShot: function()
            {
                var id = this.$route.params.id;
                this.importSnapshotsByJson(this.formValue, id);
                this.$store.dispatch("saveCurrentForecastVersion");               
            },
            importSiteEnrolments: function (enrolmentDatas) {
            
                //reset
                this.formValue.sites.forEach(site => { 
                    site.enrolmentPeriods = [];
                    site.projectionPeriods = [];                                
                });

                this.formValue.sites.forEach(site => {
                    var enrolmentData = enrolmentDatas.find(x => x.countryIsoTwo === site.address.country && x.siteName === site.name);

                    if (this.NullOrUndefined(enrolmentData))
                        return;

                    site.enrolmentPeriods = enrolmentData.enrolmentPeriods;
                    site.projectionPeriods = enrolmentData.projectionPeriods;

                });

                this.$store.dispatch("saveCurrentForecastVersion");

                this.$nextTick(() => {
                    this.$forceUpdate();
                });

            },  
            // formvalue is here a "site" section.
            RenderSiteEnrolmentTreatmentGroups: function (formValueSiteSection, globalFormValue, enrolmentSection) {
                
                //basic checks
                //debugger;
                if (this.NullOrUndefined(globalFormValue) || this.NullOrUndefined(enrolmentSection)) {
                    return;
                }
               
                if (this.NullOrUndefined(globalFormValue.treatmentGroups) || globalFormValue.treatmentGroups.length === 0) {
                    return;
                }
               
                            
                if (enrolmentSection.enrolmentPeriodTreatmentGroupPicker === "")
                {
                    enrolmentSection.enrolmentPeriodTreatmentGroupPicker = "All treatmentgroups";                        
                }                    
                
                enrolmentSection.enrolled = [];

                //make an enrolment for each trement groups
                for (var i = 0; i < globalFormValue.treatmentGroups.length; i++) {

                    var tg = globalFormValue.treatmentGroups[i];

                    var enrolledByTreatmentGroup = {
                        treatmentGroupId: tg.id,
                        description: tg.name + " (ratio:" + tg.ratio + ")",
                        enrolled: 0
                    };

                    enrolmentSection.enrolled.push(enrolledByTreatmentGroup);

                }
                
                
                this.$store.dispatch("saveCurrentForecastVersion");
                                        
            },
            PreviousSupplyPlanAvailable: function () {
                this.previousSupplyPlanAvailable = false;
                var studyId = this.$route.params.id;
                let url = "supplyplan/HasPreviousSupplyPlan?studyId=" + studyId;
                this.cancelToken = API.CancelToken.source();
                return API.get(url, {
                    cancelToken: this.cancelToken.token
                }).then((res) => {

                    if (res.data) {                        
                        this.previousSupplyPlanAvailable = res.data;
                    }
                }
                );

            }
            ,            
            ShowHideSupplyPlanJsonStyle: function () {
                this.showHideSupplyPlanJsonStyle = "display:none;";
               
                if (this.PreviousSupplyPlanAvailable)
                    this.showHideSupplyPlanJsonStyle = "display:block;";

                return this.showHideSupplyPlanJsonStyle;
            }
            ,
            /*
            updateReferences: function () {
                this.updateMetaNameReferences(this.formValue);
            },*/            
            importSupplyPlansByJsonLocal: function () {
                var id = this.$route.params.id;            
                this.importSupplyPlansByJson(this.formValue, id);
                this.formValue.autoGenerateSupplyPlans = false;
                this.showHideMinimumAndPrefferred();
            },
            importSupplyPlansByExcel: function (importedSupplyPlans) {
                
                
                this.formValue.supplyPlans = [];

                for (var i = 0; i < this.formValue.sites.length;i++) {
                    this.formValue.sites[i].supplyPlans = [];
                }

                for (var i = 0; i < this.formValue.depots.length;i++) {
                    this.formValue.depots[i].supplyPlans = [];
                }


                for (var i = 0; i < importedSupplyPlans.length; i++) {
                    

                    var plan = importedSupplyPlans[i];
                    
                    //debugger;


                    var siteIndex = this.formValue.sites.findIndex(x => x.id === plan.locationId);
                    
                    var dispensingUnitReference = null;
                    for (var tg = 0; tg < this.formValue.treatmentGroups.length; tg++) {
                        var dun = this.formValue.dispensingUnits.find(x => x.id === plan.dispensingUnitId);
                        
                        if (dun != null && dun != "undefined") {

                            dispensingUnitReference = dun.id;
                            break;
                        }                        
                    }
                                                                 
                                        
            

                    if (siteIndex >= 0) {

                        var existingPlan = this.formValue.supplyPlans.find(x=>
                            x.description == plan.description
                            &&
                            x.dispensingUnit == dispensingUnitReference
                            &&
                            x.defaultStartDate == plan.startDate
                            &&
                            x.resupplyStrategy.initial == plan.initialForFloorCeiling
                            &&
                            x.resupplyStrategy.ceiling == plan.ceilingForFloorCeiling
                            &&
                            x.resupplyStrategy.longWindow == plan.longWindowForPrediction
                            &&
                            x.trigger.floor == plan.floorForFloorCeiling
                            &&
                            x.trigger.threshold == plan.thresholdForPrediction
                            &&
                            x.trigger.shortWindow == plan.shortWindowForPrediction
                            );
                        //alert(existingPlan)
                        if (typeof existingPlan != 'undefined') {
                            existingPlan.sites.push(plan.locationId);

                            let sitePlanReference = {
                                supplyPlan: existingPlan.id,
                                startDate: existingPlan.startDate,
                                siteId: this.formValue.sites[siteIndex].id
                            };

                            this.formValue.sites[siteIndex].supplyPlans.push(sitePlanReference);
                        }
                        else {

                            let newPlan =
                            {
                                dispensingUnit: dispensingUnitReference
                                , description: plan.description
                                , defaultStartDate: !this.NullOrUndefined(plan.defaultStartDate)  && plan.defaultStartDate !== '' ? plan.defaultStartDate : plan.startDate
                                , sites: siteIndex >= 0 ? new Array(plan.locationId) : []
                                , depots: []                               
                                , id: plan.id                               
                                , SelectedStrategyType: "Floor/Ceiling"
                                , resupplyStrategy: {
                                    initial: plan.initialForFloorCeiling,
                                    ceiling: plan.ceilingForFloorCeiling,
                                    longWindow: plan.longWindowForPrediction
                                }
                                , trigger: {
                                    floor: plan.floorForFloorCeiling,
                                    threshold: plan.thresholdForPrediction,
                                    shortWindow: plan.shortWindowForPrediction
                                }
                            };

                            this.formValue.supplyPlans.push(newPlan);

                            let sitePlanReference = {
                                supplyPlan: newPlan.id,                               
                                startDate: newPlan.startDate,
                                siteId: this.formValue.sites[siteIndex].id
                            };

                            this.formValue.sites[siteIndex].supplyPlans.push(sitePlanReference);
                        }
                       
                       

                        
                    }
                  


                }
                

                this.formValue.autoGenerateSupplyPlans = false;
                this.showHideMinimumAndPrefferred();

            },
            importSites: function (importedSites) {
                var oldSites = this.formValue.sites;

                // we traverse the current list of sites, updating values and deleting removed items
                for (var i = 0; i < oldSites.length;) {
                    const currentSite = oldSites[i];
                    const j = importedSites.findIndex(x => x.id == currentSite.id);
                    if (j < 0) {
                        oldSites.splice(i, 1);
                        this.handleSiteDeleted(currentSite.id);

                        continue;
                    }

                    const newValues = importedSites[j];
                    importedSites.splice(j, 1);

                    currentSite.name = newValues.name;
                    currentSite.address = newValues.address;
                    currentSite.maxCapacity = newValues.maxCapacity;
                    currentSite.maxSubjects = newValues.maxSubjects;
                    currentSite.projection = newValues.projection;
                    currentSite.start = newValues.start;
                    
                    i++;
                }

                // we push the remaining imported sites
                oldSites.push(...importedSites);

                this.$store.dispatch("saveCurrentForecastVersion");
            },           
            autoGenerateSupplyPlans: function() {
                if (this.formValue.autoGenerateSupplyPlans) {                    

                    if (this.formValue.supplyPlans.length > 0) {
                        if (confirm("There are existing supply plans, do you want to delete them?")) {

                            for (var i = 0; i < this.formValue.sites.length; i++) {
                                this.formValue.sites[i].supplyPlans = [];
                            }

                            for (var i = 0; i < this.formValue.depots.length; i++) {
                                this.formValue.depots[i].supplyPlans = [];
                            }

                            this.formValue.supplyPlans = [];
                        }
                    }
                }
                //debugger;
                this.showHideMinimumAndPrefferred();
            }            
            ,
            importDepots: function (importedDepots) {
                var oldDepots = this.formValue.depots;

                // we traverse the current list of sites, updating values and deleting removed items
                for (var i = 0; i < oldDepots.length;) {
                    const currentDepot = oldDepots[i];
                    const j = importedDepots.findIndex(x => x.id == currentDepot.id);
                    if (j < 0) {
                        oldDepots.splice(i, 1);
                        this.handleDepotDeleted(currentDepot.id);

                        continue;
                    }

                    const newValues = importedDepots[j];
                    importedDepots.splice(j, 1);

                    currentDepot.name = newValues.name;
                    currentDepot.address = newValues.address;
                    currentDepot.description = newValues.description;

                    i++;
                }

                // we push the remaining imported depots
                oldDepots.push(...importedDepots);

                this.$store.dispatch("saveCurrentForecastVersion");
            },
            exportSites: function () {
                var sites = this.formValue.sites;

                fetch("/Api/Study/ExportSites", {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sites)
                }).then(x => {
                    return x.blob().then(y => this.saveFile(y, "Sites.xlsx"));
                });
            },
            downloadSitesTemplate: function () {
                fetch("/Api/Study/ExportSites", {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify([])
                }).then(x => {
                    return x.blob().then(y => this.saveFile(y, "Sites.xlsx"));
                });
            },
            downloadSiteEnrollments: function () {
                var studyId =  this.$route.params.id;
                var versionId = !this.NullOrUndefined( this.$route.params.versionId) ? this.$route.params.versionId : this.$store.state.editor.version.forecastVersionId;
                
                window.open('/api/download/Enrolment?studyId=' + studyId + '&versionId=' + versionId);
            },
            exportDepots: function () {
                var depots = this.formValue.depots;

                fetch("/Api/Study/ExportDepots", {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(depots)
                }).then(x => {
                    return x.blob().then(y => this.saveFile(y, "depots.xlsx"));
                });
            },
            downloadDepotsTemplate: function () {
                fetch("/Api/Study/ExportDepots", {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify([])
                }).then(x => {
                    return x.blob().then(y => this.saveFile(y, "depotTemplate.xlsx"));
                });
            },
            handleSupplyPlans(plansToSites, list) {

                // Add supply plans to all sites, or remove if not found
                for (let site of list) {
                    if (!site.supplyPlans) {
                        site.supplyPlans = [];
                    }

                    let plans = plansToSites.find(x => x.siteId == site.id);

                    // Delete plans if nothing is found
                    if (!plans) {
                        site.supplyPlans = [];
                        continue;
                    }

                    // Add new plans again
                    let newSitePlans = [];
                    for (let plan of plans.plans) {
                        let newPlan = {
                            supplyPlan: plan.id,                           
                            startDate: plan.defaultStartDate,
                            siteId: site.id
                        };

                        // Find startDate on old plan
                        let oldPlan = site.supplyPlans.find(x => x.supplyPlan == plan.id);
                        if (oldPlan) {
                            if (oldPlan.startDate != null && oldPlan.startDate != "")
                                newPlan.startDate = oldPlan.startDate;
                        }

                        newSitePlans.push(newPlan);
                    }
                    site.supplyPlans = newSitePlans;
                }
            },
            changeSupplyPlans(type, list) {
                let plansToSites = [];

                // Build plans to site list first
                for (let sp of this.formValue.supplyPlans) {
                    if (!sp[type]) {
                        sp[type] = []; // Because of legacy json
                        continue;
                    }

                    for (let site of sp[type]) {
                        let ps = plansToSites.find(x => x.siteId == site);

                        // Create new if not found
                        if (!ps) {
                            let newPs = {
                                siteId: site,
                                plans: []
                            };
                            newPs.plans.push({
                                id: sp.id,
                                name: sp.description == "" ? "Unknown" : sp.description,
                                defaultStartDate: sp.defaultStartDate
                            });
                            plansToSites.push(newPs);
                            continue;
                        }

                        // Else, add to plan
                        ps.plans.push({
                            id: sp.id,
                            name: sp.description == "" ? "Unknown" : sp.description,
                            defaultStartDate: sp.defaultStartDate
                        });
                    }
                }

                this.handleSupplyPlans(plansToSites, list);
            },
            setStockAdjustments(type,list) {
              
            },
            changeLocationSupplyPlan(type, list) {
                let siteIdList = [];
                let supplyPlans = this.formValue.supplyPlans;

                for (let site of list) {
                    for (let ss of site.supplyPlans) {
                        // Check if default start date should be updated
                        if (ss.startDate == null || ss.startDate === "") {
                            let originalPlan = supplyPlans.find(x => x.id == ss.supplyPlan)
                            if (originalPlan) {
                                ss.startDate = originalPlan.defaultStartDate;
                            }
                        }

                        let ps = siteIdList.find(x => x.planId === ss.supplyPlan);
                        if (!ps) {
                            let newSp = {
                                planId: ss.supplyPlan,
                                sites: []
                            };
                            newSp.sites.push(site.id);
                            siteIdList.push(newSp);
                            continue;
                        }

                        // Check if site is already added
                        if (ps.sites.find(x => x === site.id)) {
                            alert("Warning: This supply plan is already added");
                            site.supplyPlans.pop();
                            break;
                        }
                        else {
                            ps.sites.push(site.id);
                        }
                    }
                }

                // Update plans in 3.1
                for (let sp of supplyPlans) {
                    let plan = siteIdList.find(x => x.planId == sp.id)
                    if (!plan) {
                        sp[type] = [];
                        continue;
                    }

                    sp[type] = plan.sites;
                }
            },
            handleDepotDeleted: function (id) {
                var i = 0;
                var j = 0;

                // clean up supply plans
                var plans = this.formValue.supplyPlans;
                for (i = 0; i < plans.length; i++) {
                    var depots = plans[i].depots;

                    j = depots.findIndex(x => x == id);
                    if (j >= 0) {
                        depots.splice(j, 1);
                    }
                }

                // clean up supply chains
                var chains = this.formValue.supplyChain.reduce(function (a, b) { return a.concat(b.supplyChains); }, []);
                while (chains.length > 0) {
                    for (i = 0; i < chains.length; i++) {
                        var chain = chains[i];

                        if (chain.depotReference.id == id) {
                            chain.depotReference.id = "";                           
                        }

                        j = chain.metaDeliveryDepots.findIndex(x => x === id);
                        if (j >= 0) {
                            chain.metaDeliveryDepots.splice(j, 1);
                        }

                        j = chain.deliveryDepots.findIndex(x => x.depotReference.id == id);
                        if (j >= 0) {
                            chain.deliveryDepots.splice(j, 1);
                        }
                    }

                    var chains = chains.reduce(function (a, b) { return a.concat(b.deliveryDepots); }, []);
                }

                // clean up planned batchs
                var plannedBatchs = this.formValue.production.plannedBatchs;
                for (i = 0; i < plannedBatchs.length; i++) {
                    var pb = plannedBatchs[i];

                    j = pb.depots.findIndex(x => x.id == id);
                    if (j >= 0) {
                        pb.depots.splice(j, 1);
                    }
                }

                // clean up batch templates
                var batchTemplates = this.formValue.production.batchTemplates;
                for (i = 0; i < batchTemplates.length; i++) {
                    var bt = batchTemplates[i];

                    j = bt.depots.findIndex(x => x.id == id);
                    if (j >= 0) {
                        bt.depots.splice(j, 1);
                    }
                }
            },
            handleSiteDeleted: function (id) {
                var i = 0;
                var j = 0;

                // clean up supply plans
                var plans = this.formValue.supplyPlans;
                for (i = 0; i < plans.length; i++) {
                    var sites = plans[i].sites;

                    j = sites.findIndex(x => x == id)
                    if (j >= 0) {
                        sites.splice(j, 1);
                    }
                }

                // clean up supply chains
                var chains = this.formValue.supplyChain.reduce(function (a, b) { return a.concat(b.supplyChains); }, []);
                while (chains.length > 0) {
                    for (i = 0; i < chains.length; i++) {
                        var chain = chains[i];

                        j = chain.metaDeliverySites.findIndex(x => x == id);
                        if (j >= 0) {
                            chain.metaDeliverySites.splice(j, 1);
                        }

                        j = chain.deliverySites.findIndex(x => x.siteReference.id == id);
                        if (j >= 0) {
                            chain.deliverySites.splice(j, 1);
                        }
                    }

                    var chains = chains.reduce(function (a, b) { return a.concat(b.deliveryDepots); }, []);
                }
            },
            showHideMinimumAndPrefferred: function () {
                let index = 0;
                
                for (let i=0; i < this.formData.length; i++)
                {
                    if (this.formData[i].title === "Supply Plans")
                    {
                        index = i;
                        break;
                    }
                }
              
              
                var predictionThresholdField = this.formData[index].forms.find(x => x.id == "predictionThreshold");
                var preferredSupplyPlanField = this.formData[index].forms.find(x => x.id == "preferredSiteSupplyPlanSelect");

                if (predictionThresholdField && preferredSupplyPlanField) {
                    if (this.formValue.autoGenerateSupplyPlans && this.formValue.preferredSiteSupplyPlan == "Prediction") {
                        predictionThresholdField.style = "display:block;";
                    }
                    else {
                        predictionThresholdField.style = "display:none;";
                    }
                }

                

                if (preferredSupplyPlanField) {
                    if (this.formValue.autoGenerateSupplyPlans) {
                        preferredSupplyPlanField.style = "display:block;";
                    }
                    else {
                        preferredSupplyPlanField.style = "display:none;";
                    }
                }
                
                      
            }
        },
        watch: {
            "formValue.autoGenerateSupplyPlans": function() {                    
                this.showHideMinimumAndPrefferred();
                },
            "formValue.sites": {
                handler: function (data) {
                    // Add all DUNs when a new site is added to Site array
                    let dunList = [];
                    this.formValue.dispensingUnits.forEach((dun) => {
                        let item = {
                            dispensingUnitReference: {
                                id: dun.id,
                                name: dun.name
                            },
                            maxDunCapacity: null
                        };

                        dunList.push(item);
                    });

                    for (let site of data) {
                        if (!site.dispensingUnits)
                            site.dispensingUnits = [];

                        dunList.forEach((dun) => {
                            if (!site.dispensingUnits.find(x => x.dispensingUnitReference.id == dun.dispensingUnitReference.id))
                                site.dispensingUnits.push(dun);
                        });
                    }
                },
                deep: false
            }
        }
    };
</script>
